export { default as SearchResultError } from './error';
